import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";
// import styles from './Components.css'; 


function Statics(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Statics</h2>
                <li>
                    <Link to={`${url}/freebody`}>Free-Body Diagrams</Link>
                </li>
                <li>
                    <Link to={`${url}/forceflow`}>Force Flow Analysis</Link>
                </li>
             
                <li>
                    <Link to={`${url}/torque`}>Torque</Link>
                </li>
                <li>
                    <Link to={`${url}/forcedecomp`}>Force Decomposition</Link>
                </li>
                <li>
                    <Link to={`${url}/rigidbodies`}>Rigid Body Forces</Link>
                </li>
                <li>
                    <Link to={`${url}/moments`}>Moments</Link>
                </li>
                <li>
                    <Link to={`${url}/struts`}>Struts & Ties</Link>
                </li>
                <li>
                    <Link to={`${url}/supports`}>Supports and Loading</Link>
                </li>
                <li>
                    <Link to={`${url}/trusses`}>Trusses</Link>
                </li>
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Statics; 